import batchVisible from '../../../../../actions/batchVisible'
import {buildDetailsQueue} from '../../../../../actions/buildDetailsQueue'
import type {AppThunk} from '../../../../../actions/types'
import {fetchQueryOnce} from '../../../../../relay/fetchQueryOnce'
import getEnvironment from '../../../../../relay/getEnvironment'
import {haveDependants} from '../../../../../slices'
import {toBuildId} from '../../../../../types'
import type {BuildId} from '../../../../../types'
import {Namespace} from '../../../../../utils/namespace'

import type {BuildDependantsQuery} from './__generated__/BuildDependantsQuery.graphql'
import {buildDependantsQuery} from './BuildDependants.queries'

const receiveHaveDependants = haveDependants.actions.receive

export const fetchHasDependantsQueue: (id: BuildId) => AppThunk<void> = batchVisible({
  queue: buildDetailsQueue,
  namespace: Namespace.HAS_DEPENDANTS,
  request: id =>
    fetchQueryOnce<BuildDependantsQuery>(getEnvironment(), buildDependantsQuery, {
      buildLocator: `id:${id}`,
    }).then<readonly [BuildId, boolean][]>(data => [
      [toBuildId(id), Boolean(data.build?.related?.builds?.count)],
    ]),
  action: receiveHaveDependants,
})
